import { getFromStorage, saveToStorage } from "../Storage";

class UsedVehicleLockService {
    constructor() {
        this.lockedVehicles = this.getStoredLockedVehicles();
    }

    /**
     * Get stored locked vehicles
     * @returns Array
     */
    getStoredLockedVehicles() {
        const lockedVehicles = getFromStorage('locked_vehicles', '[]');
        try {
            return JSON.parse(lockedVehicles);
        } catch (error) {
            console.error("Error getting stored locked vehicles");
        }

        return [];
    }

    removeLockedVehicle(usedVehicleId) {
        if (this.lockedVehicles.length == 0) {
            return;
        }

        this.lockedVehicles = this.lockedVehicles.filter(lockedVehicle => {
            if (typeof lockedVehicle.id == 'undefined') {
                return false;
            }
            if (typeof lockedVehicle.ref == 'undefined') {
                return false;
            }
            if (lockedVehicle.id == usedVehicleId) {
                return false;
            }
            return true;
        })

        saveToStorage('locked_vehicles', JSON.stringify(this.lockedVehicles));

        return;
    }

    /**
     * Log locked vehicle
     * @param {Int} usedVehicleId
     * @param {String} uniqueReference
     */
    logLockedVehicle(usedVehicleId, uniqueReference) {
        try {
            this.removeLockedVehicle(usedVehicleId);

            this.lockedVehicles.push({
                'id': usedVehicleId,
                'ref': uniqueReference,
            });

            saveToStorage('locked_vehicles', JSON.stringify(this.lockedVehicles));
        } catch (error) {
            console.error('Error logging locked vehicle', error);
        }
    }

    /**
     * Get the stored lock for a vehicle (if exists)
     * @param {Int} usedVehicleId
     * @param {*} fallback
     * @returns {*}
     */
    getStoredLock(usedVehicleId, fallback = null) {
        let foundLock = false;
        Object.keys(this.lockedVehicles).forEach(key => {
            const vehicle = this.lockedVehicles[key];

            if (typeof vehicle.id == 'undefined') {
                return;
            }
            if (typeof vehicle.ref == 'undefined') {
                return;
            }
            if (vehicle.id == usedVehicleId) {
                foundLock = vehicle.ref;
            }
        });

        if (foundLock === false) {
            return fallback;
        }

        return foundLock;
    }
}

const usedVehicleLockService = new UsedVehicleLockService;

export { usedVehicleLockService };